import { BlueskySettingKey } from '$extensionSrc/recommendations/recommendationSettingsKeys'
import { BlueskyRecommendationKey, StageType } from '$extensionSrc/utils/enums'

import { StageDef } from '../automationMachineInterfaces'
import * as blueskyUrls from './blueskyUrls'
import { AUTOMATION_STAGE_STATUSES } from '../genericAutomationStageStatuses'
import {
  getIsFulfilledFnFromKey,
  defaultCantUndoFn,
  getCurrentValueFnFromKey,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
} from '../recommendationCardDisplayUtils'

// Settings property functions
export const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => value)

export const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(key, (value) => !value.endsWith('bsky.social'))

export const getCantUndoFn = () => defaultCantUndoFn
export const getIsDisabledFn = () => defaultIsDisabledFn
export const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

enum StageKey {
  GATHER_VERIFIED_DOMAIN = 'GATHER_VERIFIED_DOMAIN',
}

export const gatherStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.GATHER_VERIFIED_DOMAIN,
    status: AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: blueskyUrls.privacySecurityUrl,
    action: async (_machineContext, userContext) => {
      const { updateStoredInitialValues, platformAccountUsername } = userContext

      if (
        platformAccountUsername === undefined ||
        platformAccountUsername === null ||
        platformAccountUsername === ''
      ) {
        throw new Error('Platform account username not found')
      }
      let domain = platformAccountUsername
      if (platformAccountUsername.endsWith('bsky.social')) {
        domain = 'bsky.social'
      }

      await updateStoredInitialValues(
        {
          [BlueskySettingKey.DOMAIN_VERIFICATION]: domain,
        },
        BlueskyRecommendationKey.BLUESKY_DOMAIN_VERIFICATION,
      )
    },
  },
]

export const updateStageDefs: StageDef[] = []
export const undoStageDefs: StageDef[] = []
